import { useAppContext } from '@ifixit/app/hooks';
import { invariant } from '@ifixit/helpers';
import { isStoreLocaleCode } from './helpers';
import { type LocaleCode } from './types';

export function useStoreLocale(): LocaleCode {
   const { storeLocale } = useAppContext();
   invariant(isStoreLocaleCode(storeLocale), `Unsupported store locale code "${storeLocale}"`);
   return storeLocale;
}

export function useCustomMessage<T>(values: Record<LocaleCode, T>): T {
   const localeCode = useStoreLocale();
   return values[localeCode];
}

export function usePartialCustomMessage<T, D = null>(
   values: Partial<Record<LocaleCode, T>>,
   fallback?: D
): T | D {
   const localeCode = useStoreLocale();
   return values[localeCode] ?? fallback ?? (null as D);
}
